// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.btn {
  border-radius: 12px;
  font-family: Roboto;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.btn:disabled {
  color: #9CA3AF;
}
.btn-container {
  display: flex;
  gap: 1.5rem;
  margin: auto;
  justify-content: center;
  flex-direction: column-reverse;
}
@media (min-width: 640px) {
.btn-container {
    flex-direction: row;
}
}
.btn-primary {
  background-color: #10213E;
  color: #FFFFFF;
}
.btn-primary:hover {
  background-color: #475A7D;
  color: #FFFFFF;
}
.btn-primary:disabled {
  background-color: #E5E7EB;
}
.btn-container .btn-primary {
  width: 100%;
}
@media (min-width: 640px) {
.btn-container .btn-primary {
    width: -moz-fit-content;
    width: fit-content;
}
}
.fotocasa .btn-primary {
  background-color: #303AB2;
  font-weight: 700;
}
.btn-secondary {
  background-color: transparent;
  border-width: 2px;
  color: #10213E;
  box-sizing: border-box;
  border-color: #10213E;
}
.btn-secondary:hover {
  border-color: #475A7D;
  color: #475A7D;
}
.btn-secondary:disabled {
  border-color: #9CA3AF;
  color: #9CA3AF;
}
.fotocasa .btn-secondary {
  font-weight: 700;
}
.btn-ghost {
  background-color: transparent;
  border-width: 2px;
  color: #10213E;
  box-sizing: border-box;
  border-color: transparent;
}
.btn-ghost:hover {
  color: #475A7D;
}
.fotocasa .btn-ghost {
  color: #303AB2;
}
.btn-link {
  background: url(/img/web/icons/link.svg);
  background-repeat: no-repeat;
  background-position: center;
  padding: 1.5rem;
  position: relative;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 100%;
  border-color: #E5E7EB;
}
.btn-link:hover {
  cursor: pointer;
}
.btn-md {
  padding: 0.5rem 1rem;
  line-height: 1.5;
  font-size: 1rem;
}
.btn-lg {
  padding: 1rem 1.5rem;
  line-height: 1.35;
  font-size: 1.125rem;
}
.fotocasa .btn-lg {
  padding: 0.5rem 2rem;
  font-size: 15px;
}
.btn-social {
  display: flex;
  width: 100%;
  padding: 0.75rem 0;
  border-radius: 12px;
  justify-content: center;
  gap: 1rem;
  background-color: #F3F4F6;
  color: #6B7280;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-x-0 {
  left: 0;
  right: 0;
}
.bottom-0 {
  bottom: 0;
}
.left-0 {
  left: 0;
}
.right-0 {
  right: 0;
}
.top-0 {
  top: 0;
}
.z-0 {
  z-index: 0;
}
.z-\\[5\\] {
  z-index: 5;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-0 {
  margin: 0;
}
.m-\\[\\.125rem\\] {
  margin: .125rem;
}
.m-xs {
  margin: 2rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.\\!mb-micro {
  margin-bottom: 0.75rem !important;
}
.mb-quark {
  margin-bottom: 0.25rem;
}
.mb-sm {
  margin-bottom: 2.5rem;
}
.mb-xl {
  margin-bottom: 4rem;
}
.mb-xs {
  margin-bottom: 2rem;
}
.mb-xxxs {
  margin-bottom: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.ml-micro {
  margin-left: 0.75rem;
}
.ml-nano {
  margin-left: 0.5rem;
}
.ml-xxl {
  margin-left: 5rem;
}
.mr-nano {
  margin-right: 0.5rem;
}
.mt-0 {
  margin-top: 0;
}
.mt-md {
  margin-top: 3rem;
}
.mt-micro {
  margin-top: 0.75rem;
}
.mt-nano {
  margin-top: 0.5rem;
}
.mt-quark {
  margin-top: 0.25rem;
}
.mt-sm {
  margin-top: 2.5rem;
}
.mt-xs {
  margin-top: 2rem;
}
.mt-xxs {
  margin-top: 1.5rem;
}
.mt-xxxs {
  margin-top: 1rem;
}
.line-clamp-5 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.hidden {
  display: none;
}
.h-\\[14\\.5rem\\] {
  height: 14.5rem;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-sm {
  height: 2.5rem;
}
.min-h-fit {
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.min-h-full {
  min-height: 100%;
}
.w-0 {
  width: 0;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[19rem\\] {
  width: 19rem;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[4rem\\] {
  width: 4rem;
}
.w-full {
  width: 100%;
}
.w-sm {
  width: 2.5rem;
}
.w-xxl {
  width: 5rem;
}
.min-w-\\[unset\\] {
  min-width: unset;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-micro {
  gap: 0.75rem;
}
.gap-nano {
  gap: 0.5rem;
}
.overflow-x-auto {
  overflow-x: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.\\!rounded-md {
  border-radius: 12px !important;
}
.rounded-lg {
  border-radius: 30px;
}
.rounded-md {
  border-radius: 12px;
}
.rounded-s {
  border-radius: 6px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.border-hairline {
  border-width: 1px;
}
.border-none {
  border-width: 0px;
}
.border-l-none {
  border-left-width: 0px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.border-feedback-error-medium {
  --tw-border-opacity: 1;
  border-color: rgb(216 0 3 / var(--tw-border-opacity));
}
.border-neutral-light {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-neutral-semilight {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.\\!bg-support-medium {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(129 197 238 / var(--tw-bg-opacity)) !important;
}
.bg-brand-primary-medium {
  --tw-bg-opacity: 1;
  background-color: rgb(234 178 38 / var(--tw-bg-opacity));
}
.bg-neutral-lightest {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-neutral-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-support-light {
  --tw-bg-opacity: 1;
  background-color: rgb(219 238 250 / var(--tw-bg-opacity));
}
.bg-support-lightest {
  --tw-bg-opacity: 1;
  background-color: rgb(237 247 253 / var(--tw-bg-opacity));
}
.fill-current {
  fill: currentColor;
}
.p-0 {
  padding: 0;
}
.p-xxxs {
  padding: 1rem;
}
.px-nano {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-xxs {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-xxxs {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.py-micro {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-nano {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.\\!pt-micro {
  padding-top: 0.75rem !important;
}
.pb-md {
  padding-bottom: 3rem;
}
.pb-xs {
  padding-bottom: 2rem;
}
.pr-\\[1\\.873rem\\] {
  padding-right: 1.873rem;
}
.pt-micro {
  padding-top: 0.75rem;
}
.pt-xl {
  padding-top: 4rem;
}
.pt-xxs {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.\\!text-right {
  text-align: right !important;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.font-highlight {
  font-family: Mont;
}
.text-nano {
  font-size: 0.875rem;
}
.text-sm {
  font-size: 1.125rem;
}
.text-xl {
  font-size: 2rem;
}
.text-xs {
  font-size: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.text-brand-secondary {
  --tw-text-opacity: 1;
  color: rgb(31 47 75 / var(--tw-text-opacity));
}
.text-brand-secondary-medium {
  --tw-text-opacity: 1;
  color: rgb(31 47 75 / var(--tw-text-opacity));
}
.text-feedback-error {
  --tw-text-opacity: 1;
  color: rgb(216 0 3 / var(--tw-text-opacity));
}
.text-neutral-darkest {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-neutral-grayish {
  --tw-text-opacity: 1;
  color: rgb(167 178 196 / var(--tw-text-opacity));
}
.text-neutral-medium {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-neutral-semidark {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-neutral-ultradark {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-neutral-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.style-display-bold {
  font-family: Mont;
  line-height: 1;
  font-size: 3.75rem;
  font-weight: 700;
}
.style-subtitle-bold {
  font-family: Mont;
  line-height: 1.35;
  font-size: 1.5rem;
  font-weight: 700;
}
.style-body-sm {
  font-family: Roboto;
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 400;
}
.style-body-sm-bold {
  font-family: Roboto;
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 700;
}
.style-overline {
  font-family: Roboto;
  line-height: 1.5;
  font-size: 0.875rem;
  font-weight: 400;
}
.style-overline-underline {
  font-family: Roboto;
  line-height: 1.5;
  font-size: 0.875rem;
  font-weight: 400;
  text-decoration: underline;
}
.style-overline-bold {
  font-family: Roboto;
  line-height: 1.5;
  font-size: 0.875rem;
  font-weight: 700;
}
.container {
  width: 100%;
  padding-right: 1rem;
  padding-left: 1rem;
  margin: auto;
}
@media (min-width: 640px) {
.container {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
}
.container-thinner {
    width: calc((100vw - 1.5rem) / 8 * 4 + 1.5rem);
}
.container-thin {
    width: calc((100vw - 1.5rem) / 8 * 6 + 1.5rem);
}
}
@media (min-width: 1320px) {
.container {
    max-width: 1320px;
}
.container-thinner {
    width: calc((1320px - 1.5rem) / 12 * 10 + 1.5rem);
}
.container-thin {
    width: calc((1320px - 1.5rem) / 12 * 8 + 1.5rem);
}
.container-medium {
    width: calc((1320px - 1.5rem) / 12 * 10 + 1.5rem);
}
}
.icon {
  flex-shrink: 0;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
}
.icon-micro {
  width: 0.75rem;
  height: 0.75rem;
}
.icon-xxxs {
  width: 1rem;
  height: 1rem;
}
.icon-xxs {
  width: 1.5rem;
  height: 1.5rem;
}
.icon-star {
  background-image: url("/img/web/icons/star.svg");
}
.icon-star-black {
  background-image: url("/img/web/icons/star-black.svg");
}
.icon-question {
  background-image: url("/img/web/icons/question.svg");
}
.icon-question-dark {
  background-image: url("/img/web/icons/question-dark.svg");
}
.icon-warning {
  background-image: url("/img/web/icons/warning.svg");
}
.icon-arrow {
  background-image: url("/img/web/icons/arrow.svg");
}
.fotocasa .icon-arrow {
  background-image: url("/img/fotocasa-hipotecas/icons/arrow.svg");
}
.icon-stats {
  background-image: url("/img/web/icons/stats.svg");
}
.icon-home {
  background-image: url("/img/web/icons/home.svg");
}
.icon-clock {
  background-image: url("/img/web/icons/clock.svg");
}
.fotocasa .icon-clock {
  background-image: url("/img/fotocasa-hipotecas/icons/clock.svg");
}
.icon-calendar {
  background-image: url("/img/web/icons/calendar.svg");
}
.fotocasa .icon-calendar {
  background-image: url("/img/fotocasa-hipotecas/icons/calendar.svg");
}
.icon-magnifying {
  background-image: url("/img/web/icons/magnifying.svg");
}
.icon-arrow-lg {
  background-image: url("/img/web/form/right-arrow-btn.svg");
}
.hover\\:cursor-text:hover {
  cursor: text;
}
@media (min-width: 640px) {
.sm\\:mt-0 {
    margin-top: 0;
}
.sm\\:table-cell {
    display: table-cell;
}
.sm\\:w-auto {
    width: auto;
}
.sm\\:px-xxs {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
}
@media (min-width: 768px) {
.md\\:inline {
    display: inline;
}
.md\\:hidden {
    display: none;
}
}
@media (min-width: 996px) {
.lg\\:relative {
    position: relative;
}
.lg\\:float-right {
    float: right;
}
.lg\\:ml-xl {
    margin-left: 4rem;
}
.lg\\:ml-xxs {
    margin-left: 1.5rem;
}
.lg\\:mr-0 {
    margin-right: 0;
}
.lg\\:mr-\\[25\\%\\] {
    margin-right: 25%;
}
.lg\\:mr-xxxs {
    margin-right: 1rem;
}
.lg\\:mt-0 {
    margin-top: 0;
}
.lg\\:mt-xxs {
    margin-top: 1.5rem;
}
.lg\\:line-clamp-4 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
}
.lg\\:flex {
    display: flex;
}
.lg\\:hidden {
    display: none;
}
.lg\\:h-full {
    height: 100%;
}
.lg\\:h-md {
    height: 3rem;
}
.lg\\:w-1\\/2 {
    width: 50%;
}
.lg\\:w-md {
    width: 3rem;
}
.lg\\:max-w-full {
    max-width: 100%;
}
.lg\\:flex-row {
    flex-direction: row;
}
.lg\\:flex-col {
    flex-direction: column;
}
.lg\\:justify-end {
    justify-content: flex-end;
}
.lg\\:justify-center {
    justify-content: center;
}
.lg\\:justify-between {
    justify-content: space-between;
}
.lg\\:gap-\\[2\\.25rem\\] {
    gap: 2.25rem;
}
.lg\\:self-start {
    align-self: flex-start;
}
.lg\\:overflow-x-clip {
    overflow-x: clip;
}
.lg\\:border-none {
    border-width: 0px;
    border-style: none;
}
.lg\\:bg-neutral-lightest {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.lg\\:p-0 {
    padding: 0;
}
.lg\\:px-0 {
    padding-left: 0;
    padding-right: 0;
}
.lg\\:py-xxxl {
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
}
.lg\\:pr-xxs {
    padding-right: 1.5rem;
}
.lg\\:pr-xxxs {
    padding-right: 1rem;
}
.lg\\:pt-\\[4\\.75rem\\] {
    padding-top: 4.75rem;
}
.lg\\:text-left {
    text-align: left;
}
.lg\\:transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.lg\\:duration-300 {
    transition-duration: 300ms;
}
.lg\\:style-title-bold {
    font-family: Mont;
    line-height: 1;
    font-size: 2.5rem;
    font-weight: 700;
}
.lg\\:style-body {
    font-family: Roboto;
    line-height: 1.35;
    font-size: 1.125rem;
    font-weight: 400;
}
.lg\\:style-body-bold {
    font-family: Roboto;
    line-height: 1.35;
    font-size: 1.125rem;
    font-weight: 700;
}
.lg\\:style-body-sm {
    font-family: Roboto;
    line-height: 1.5;
    font-size: 1rem;
    font-weight: 400;
}
.lg\\:overflow-x-clip {
    overflow-x: clip;
}
.lg\\:col-4-8 {
    width: calc((100vw - 1.5rem) / 8 * 4 - 1.5rem);
}
}
@media (min-width: 1320px) {
.xl\\:ml-xxl {
    margin-left: 5rem;
}
.xl\\:mr-micro {
    margin-right: 0.75rem;
}
.xl\\:mr-quark {
    margin-right: 0.25rem;
}
.xl\\:pr-0 {
    padding-right: 0;
}
.xl\\:col-5-12 {
    width: calc((1320px - 1.5rem) / 12 * 5 - 1.5rem);
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/layouts/Skeleton.vue"],"names":[],"mappings":"AAQA;;CAAA,CAAA;;;CAAA;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,0BAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;CAAA;AAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,4NAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;CAAA;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;AAAA;AACA;EAAA,mBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,eAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,aAAA;EAAA,WAAA;EAAA,YAAA;EAAA,uBAAA;EAAA,8BAAA;AAAA;AAAA;AAAA;IAAA,mBAAA;AAAA;AAAA;AAAA;EAAA,yBAAA;EAAA,cAAA;AAAA;AAAA;EAAA,yBAAA;EAAA,cAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;AAAA;IAAA,uBAAA;IAAA,kBAAA;AAAA;AAAA;AAAA;EAAA,yBAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,sBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,sBAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,eAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,SAAA;EAAA,yBAAA;EAAA,cAAA;AAAA;AACA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,OAAA;EAAA,QAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,OAAA;AAAA;AAAA;EAAA,QAAA;AAAA;AAAA;EAAA,MAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iCAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,QAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,+LAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,qDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,oEAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,cAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,mCAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA,kHAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,YAAA;AAAA;AAAA;AAAA;IAAA,qBAAA;IAAA,oBAAA;AAAA;AAAA;IAAA,8CAAA;AAAA;AAAA;IAAA,8CAAA;AAAA;AAAA;AAAA;AAAA;IAAA,iBAAA;AAAA;AAAA;IAAA,iDAAA;AAAA;AAAA;IAAA,gDAAA;AAAA;AAAA;IAAA,iDAAA;AAAA;AAAA;AAAA;EAAA,cAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,WAAA;EAAA,YAAA;AAAA;AAAA;EAAA,aAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,oDAAA;AAAA;AAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,gEAAA;AAAA;AAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,gEAAA;AAAA;AAAA;EAAA,oDAAA;AAAA;AAAA;EAAA,mEAAA;AAAA;AAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,0DAAA;AAAA;AAVA;EAAA,YAAA;AAWA;AAXA;AAAA;IAAA,aAAA;AAWA;AAXA;IAAA,mBAAA;AAWA;AAXA;IAAA,WAAA;AAWA;AAXA;IAAA,oBAWA;IAXA,qBAAA;AAWA;AAAA;AAXA;AAAA;IAAA,eAAA;AAWA;AAXA;IAAA,aAAA;AAWA;AAAA;AAXA;AAAA;IAAA,kBAAA;AAWA;AAXA;IAAA,YAAA;AAWA;AAXA;IAAA,iBAAA;AAWA;AAXA;IAAA,mBAAA;AAWA;AAXA;IAAA,eAAA;AAWA;AAXA;IAAA,iBAAA;AAWA;AAXA;IAAA,kBAAA;AAWA;AAXA;IAAA,aAAA;AAWA;AAXA;IAAA,kBAAA;AAWA;AAXA;IAAA,gBAWA;IAXA,oBAWA;IAXA,4BAWA;IAXA,qBAAA;AAWA;AAXA;IAAA,aAAA;AAWA;AAXA;IAAA,aAAA;AAWA;AAXA;IAAA,YAAA;AAWA;AAXA;IAAA,YAAA;AAWA;AAXA;IAAA,UAAA;AAWA;AAXA;IAAA,WAAA;AAWA;AAXA;IAAA,eAAA;AAWA;AAXA;IAAA,mBAAA;AAWA;AAXA;IAAA,sBAAA;AAWA;AAXA;IAAA,yBAAA;AAWA;AAXA;IAAA,uBAAA;AAWA;AAXA;IAAA,8BAAA;AAWA;AAXA;IAAA,YAAA;AAWA;AAXA;IAAA,sBAAA;AAWA;AAXA;IAAA,gBAAA;AAWA;AAXA;IAAA,iBAWA;IAXA,kBAAA;AAWA;AAXA;IAAA,kBAWA;IAXA,yDAAA;AAWA;AAXA;IAAA,UAAA;AAWA;AAXA;IAAA,eAWA;IAXA,gBAAA;AAWA;AAXA;IAAA,mBAWA;IAXA,sBAAA;AAWA;AAXA;IAAA,qBAAA;AAWA;AAXA;IAAA,mBAAA;AAWA;AAXA;IAAA,oBAAA;AAWA;AAXA;IAAA,gBAAA;AAWA;AAXA;IAAA,wBAWA;IAXA,wDAWA;IAXA,0BAAA;AAWA;AAXA;IAAA,0BAAA;AAWA;AAXA;IAAA,iBAWA;IAXA,cAWA;IAXA,iBAWA;IAXA,gBAAA;AAWA;AAXA;IAAA,mBAWA;IAXA,iBAWA;IAXA,mBAWA;IAXA,gBAAA;AAWA;AAXA;IAAA,mBAWA;IAXA,iBAWA;IAXA,mBAWA;IAXA,gBAAA;AAWA;AAXA;IAAA,mBAWA;IAXA,gBAWA;IAXA,eAWA;IAXA,gBAAA;AAWA;AAXA;IAAA,gBAAA;AAWA;AAXA;IAAA,8CAAA;AAWA;AAAA;AAXA;AAAA;IAAA,iBAAA;AAWA;AAXA;IAAA,qBAAA;AAWA;AAXA;IAAA,qBAAA;AAWA;AAXA;IAAA,gBAAA;AAWA;AAXA;IAAA,gDAAA;AAWA;AAAA","sourcesContent":["<template>\n  <div>\n    <SeoHead />\n    <slot />\n  </div>\n</template>\n\n<style lang=\"postcss\">\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n</style>\n\n<script>\nimport SeoHead from '@/lego/layouts/SeoHead.vue';\n\nexport default {\n  components: {\n    SeoHead,\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
